import type { MutationOptions } from '@tanstack/react-query';
import { apiClient } from '@/libs/axios';
import {
  toSigninDTO,
  type SigninDTO,
  type SigninPayload,
} from '../schemas/sign-in.schema';
import type { AxiosError } from 'axios';

export const signIn = async (data: SigninPayload): Promise<SigninDTO> => {
  const url = '/auth/login';
  const response = await apiClient.post(url, data);

  return toSigninDTO(response);
};

export const signInMutationOptions = (): MutationOptions<
  SigninDTO,
  AxiosError,
  SigninPayload
> => ({
  mutationFn: signIn,
});
